import React, { useState, useEffect } from "react";
import "./ManufacturingHeader.css";
import { NavLink } from "react-router-dom";
import logowithoutbg from "../../assets/images/logo_bgremove.png";

const ManufacturingDividingHeaderPage = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const isTop = scrollTop < 100;
      setIsScrolled(!isTop);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <div className={`small-header ${isScrolled ? "scrolled" : ""}`}>
        <marquee className="blink">
          <p>Factory Digital Transformation</p>
        </marquee>
      </div>
      <nav className={`custom-header-unique ${isScrolled ? "scrolled" : ""}`}>
        <input type="checkbox" id="nav-toggle-unique" />
        <div className="logo-unique">
          <NavLink to="/DividingPage">
            <img
              className="header-logo-withoutbg"
              src={logowithoutbg}
            />
          </NavLink>
        </div>

        <ul className="links-unique">
          <li>
            <NavLink
              className="a-link"
              to="/ManufacturingLandingPage"
              activeClassName="active"
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              className="a-link"
              to="/ManufacturingProductPage"
              activeClassName="active"
            >
              Products
            </NavLink>
          </li>
          <li>
            <NavLink
              className="a-link"
              to="/ManufacturingServicePage"
              activeClassName="active"
            >
              Services
            </NavLink>
          </li>
          <li>
            <NavLink
              className="a-link"
              to="/ManufacturingCaseStudyPage"
              activeClassName="active"
            >
              Case Studies
            </NavLink>
          </li>
          <li>
            <NavLink
              className="a-link"
              to="/JobBoard"
              activeClassName="active"
            >
              Job Openings
            </NavLink>
          </li>
          <li>
            <NavLink
              className="a-link"
              to="/ManufacturingContactUs"
              activeClassName="active"
            >
              Contact
            </NavLink>
          </li>
        </ul>
        <label htmlFor="nav-toggle-unique" className="icon-burger-unique">
          <div className="line-unique"></div>
          <div className="line-unique"></div>
          <div className="line-unique"></div>
        </label>
      </nav>
    </div>
  );
};

export default ManufacturingDividingHeaderPage;
